import { render, staticRenderFns } from "./topic-info-panel.vue?vue&type=template&id=2b5ce4b6"
import script from "./topic-info-panel.ts?vue&type=script&lang=ts&external"
export * from "./topic-info-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./topic-info-panel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports